import React from 'react'
import { NotificationContext } from './index'
import { NotificationContextInterface } from './NotificationContext'

export const withNotificationContext = <P extends object>(Component: React.ComponentType<P>) => {
  return function ComponentWrappedWithNotification(
    props: Pick<P, Exclude<keyof P, keyof NotificationContextInterface>>,
  ) {
    return (
      <NotificationContext.Consumer>
        {(context: NotificationContextInterface) => (
          <Component {...(props as P)} setNotification={context.setNotification} />
        )}
      </NotificationContext.Consumer>
    )
  }
}
